import useFetch from "../../../hooks/useFetch";
import CareerPathDetailsTemplate from "../../templates/CareerPathDetailsTemplate/CareerPathDetailsTemplate";
import { careerPathsRepository } from "../../../repository/careerPaths.repository";
import { useEffect, useContext } from "react";
import { Loader } from "../../atoms/Loader/Loader";
import { useDocumentTitleLoading } from "../../../hooks/useDocumentTitle";
import { PostContext } from "../../../contexts/PostContext";

const CareerPathDetails = ({ match }) => {
  const { data, fetchData, resetData } = useFetch();
  const { isResponseOk } = useContext(PostContext);

  useDocumentTitleLoading();

  useEffect(() => {
    if (isResponseOk || !data) {
      fetchData(careerPathsRepository.getCareerPathDetails(match.params.id));
    }
  }, [isResponseOk]);

  // Handle picking search result
  useEffect(() => {
    if (data) {
      resetData();
      fetchData(careerPathsRepository.getCareerPathDetails(match.params.id));
    }
  }, [match.params.id]);

  return data ? (
    <CareerPathDetailsTemplate data={data} />
  ) : (
    <Loader />
  );
};

export default CareerPathDetails;
